// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/deicing-anti-icing-fluids.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/deicing-anti-icing-fluids/deicing-anti-icing-fluids.js';

mount([g0]);
